import React from "react";
import { Card } from "react-bootstrap";
import _ from "lodash";
import "../../styles/components/MapperTransactionReport.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilesMedical } from "@fortawesome/pro-solid-svg-icons";

const MapperTransactionReport = (props) => {
  const data = props.data;
  let total = 0;
  Object.entries(data).map(([key, value]) => (total += value.total));
  return (
    <>
      <div className="mapper-profile">
        <div className="header my-flex" style={{ padding: "0.5rem" }}>
          <div
            className="header-icon"
            style={{ display: "flex", alignItems: "center" }}
          >
            <FontAwesomeIcon
              icon={faFilesMedical}
              style={{ color: "#0758e4", fontSize: "20px" }}
            />
            <h5
              style={{
                fontWeight: "600",
                fontSize: "1.1rem",
                marginBottom: "0",
                marginLeft: "8px",
              }}
            >
              Mapper Profiles
            </h5>
          </div>
          <p>
            <strong style={{ fontSize: "1rem" }}>{total} </strong>
            <span className="light-text" style={{ fontSize: "1rem" }}>
              {" "}
              / Total No. Active Profile{" "}
            </span>
          </p>
        </div>
        <div className="my-flex">
          {Object.entries(data).map(([key, value]) => (
            <Card className="m-2 card w-100 py-1 px-1" key={key}>
              <div className="card-heading my-flex p-0 py-1">
                <p style={{ fontSize: "0.8rem", fontWeight: "600" }}>
                  {_.upperCase(key)}
                </p>
                <span>
                  <strong style={{ fontSize: "0.7rem" }}>{value.total}</strong>
                  <span className="light-text" style={{ fontSize: "0.7rem" }}>
                    {" "}
                    / Total
                  </span>
                </span>
              </div>
              <Card.Body className="card-data d-flex p-2">
                <div className="w-50 mr-2">
                  <h6 style={{ color: "#919191" }}>New</h6>
                  <strong style={{ color: "#06741A" }}>{value.new}</strong>
                </div>
                <div className="w-50">
                  <h6 style={{ color: "#919191" }}>Deleted</h6>
                  <strong style={{ color: "#C4061A" }}>{value.deleted}</strong>
                </div>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
    </>
  );
};

export default MapperTransactionReport;
